import axios from 'axios';

const getHistoryList = (storyId) => {
  return axios.get(`/history/${storyId}`).then((res) => res.data);
};

export default getHistoryList;
